import { X } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface EditDetailsModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export default function EditDetailsModal({ isOpen, onClose }: EditDetailsModalProps) {
  if (!isOpen) return null;

  return (
    <>
      {/* Backdrop */}
      <div 
        className="fixed inset-0 bg-black/50 z-40 transition-opacity"
        onClick={onClose}
      />

      {/* Side Modal */}
      <div className="fixed right-0 top-0 h-full w-full md:max-w-2xl bg-white z-50 shadow-2xl overflow-y-auto">
        <div className="p-4 md:p-8">
          {/* Header */}
          <div className="flex items-center justify-between mb-6 md:mb-8">
            <h2 className="text-2xl md:text-3xl font-bold text-gray-900 text-start">Edit Details</h2>
            <button
              onClick={onClose}
              className="w-10 h-10 flex items-center justify-center rounded-full hover:bg-gray-100 transition-colors"
            >
              <X className="w-6 h-6 text-gray-600" />
            </button>
          </div>

          {/* Form */}
          <form className="space-y-6">
            {/* First Name */}
            <div>
              <label className="block text-base font-semibold text-gray-900 mb-2 text-start">
                First Name
              </label>
              <input
                type="text"
                defaultValue="Success"
                className="w-full px-4 py-3 border border-gray-200 rounded-xl text-base focus:outline-none focus:ring-2 focus:ring-gray-200 focus:border-transparent"
              />
            </div>

            {/* Last Name */}
            <div>
              <label className="block text-base font-semibold text-gray-900 mb-2 text-start">
                Last Name
              </label>
              <input
                type="text"
                defaultValue="Olatunde"
                className="w-full px-4 py-3 border border-gray-200 rounded-xl text-base focus:outline-none focus:ring-2 focus:ring-gray-200 focus:border-transparent"
              />
            </div>

            {/* Gender */}
            <div>
              <label className="block text-base font-semibold text-gray-900 mb-2 text-start">
                Gender
              </label>
              <select
                className="w-full px-4 py-3 border border-gray-200 rounded-xl text-base text-gray-500 focus:outline-none focus:ring-2 focus:ring-gray-200 focus:border-transparent"
              >
                <option>Select gender</option>
                <option>Male</option>
                <option>Female</option>
                <option>Other</option>
              </select>
            </div>

            {/* Email */}
            <div>
              <label className="block text-base font-semibold text-gray-900 mb-2 text-start">
                Email
              </label>
              <input
                type="email"
                defaultValue="johndoe@mail.com"
                className="w-full px-4 py-3 border border-gray-200 rounded-xl text-base focus:outline-none focus:ring-2 focus:ring-gray-200 focus:border-transparent"
              />
            </div>

            {/* Phone Number */}
            <div>
              <label className="block text-base font-semibold text-gray-900 mb-2 text-start">
                Phone Number
              </label>
              <input
                type="tel"
                defaultValue="07034342258"
                className="w-full px-4 py-3 border border-gray-200 rounded-xl text-base focus:outline-none focus:ring-2 focus:ring-gray-200 focus:border-transparent"
              />
            </div>

            {/* Country */}
            <div>
              <label className="block text-base font-semibold text-gray-900 mb-2 text-start">
                Country
              </label>
              <input
                type="text"
                defaultValue="**********************"
                className="w-full px-4 py-3 border border-gray-200 rounded-xl text-base focus:outline-none focus:ring-2 focus:ring-gray-200 focus:border-transparent"
              />
            </div>

            {/* State */}
            <div>
              <label className="block text-base font-semibold text-gray-900 mb-2 text-start">
                State
              </label>
              <input
                type="text"
                defaultValue="**********************"
                className="w-full px-4 py-3 border border-gray-200 rounded-xl text-base focus:outline-none focus:ring-2 focus:ring-gray-200 focus:border-transparent"
              />
            </div>

            {/* Submit Button */}
            <div className="pt-6">
              <Button
                type="submit"
                className="w-full bg-gray-900 hover:bg-gray-800 text-white py-4 rounded-xl text-base font-semibold"
              >
                Sign Up
              </Button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}
